module.exports = __webpack_public_path__ + "grip-strength-male.072dbf240e9ef10e1c4a9af9847eb19a.png";